import React from 'react';
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react';
import { initConsent } from './lib/consent'
import './lib/i18n'
import App from './App.tsx'
import './tokens.generated.css'
import './index.css'

// Initialize Sentry error monitoring (production only)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.1,
  enabled: import.meta.env.PROD,
});

// Read cross-domain consent cookie before rendering
initConsent();

const SentryApp = Sentry.withProfiler(App);

createRoot(document.getElementById("root")!).render(<SentryApp />);
